import {useState} from 'react'
import {UserContext} from '../contexts'

const UserProvider = (props) => {
    const [user, setUser] = useState()
    const {children} = props

    return (
        <UserContext.Provider value={{user, setUser,}}>
            {children}
        </UserContext.Provider>
    )
}

export default UserProvider